import { useSelector } from "react-redux";

import BlankPage from "./blank/BlankPage";
import ScramblePage from "./scramble/ScramblePage";
import CompositionPage from "./composition/CompositionPage";
import TranslationPage from "./translation/TranslationPage";
import ComprehensivePage from "./comprehensive/ComprehensivePage";

const SentencePage = ({ setCurrentStep, isPreview, isReview }) => {
  const { section } = useSelector((state) => state.assignment);

  if (section.type === "blank") {
    return (
      <BlankPage
        setCurrentStep={setCurrentStep}
        isPreview={isPreview}
        isReview={isReview}
      />
    );
  } else if (section.type === "scramble") {
    return (
      <ScramblePage
        setCurrentStep={setCurrentStep}
        isPreview={isPreview}
        isReview={isReview}
      />
    );
  } else if (section.type === "composition") {
    return (
      <CompositionPage
        setCurrentStep={setCurrentStep}
        isPreview={isPreview}
        isReview={isReview}
      />
    );
  } else if (section.type === "translation") {
    return (
      <TranslationPage
        setCurrentStep={setCurrentStep}
        isPreview={isPreview}
        isReview={isReview}
      />
    );
  } else if (section.type === "comprehensive") {
    return (
      <ComprehensivePage
        setCurrentStep={setCurrentStep}
        isPreview={isPreview}
        isReview={isReview}
      />
    );
  }

  return (
    <div>
      <h1>Sentence Section Page</h1>
    </div>
  );
};

export default SentencePage;
